module.exports = __webpack_public_path__ + "img/media.47d0f701.svg";